import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Auth & SSO
export const getSSOConfig = () => axios.get(`${API}/auth/sso/config`);
export const ssoCallback = (data) => axios.post(`${API}/auth/sso/callback`, data);

// Users
export const getUsers = () => axios.get(`${API}/users`);
export const createUser = (data) => axios.post(`${API}/users`, data);
export const updateUser = (id, data) => axios.put(`${API}/users/${id}`, data);
export const deleteUser = (id) => axios.delete(`${API}/users/${id}`);

// Visit Purposes
export const getVisitPurposes = () => axios.get(`${API}/visit-purposes`);
export const createVisitPurpose = (data) => axios.post(`${API}/visit-purposes`, data);
export const deleteVisitPurpose = (id) => axios.delete(`${API}/visit-purposes/${id}`);

// Companies
export const getCompanies = () => axios.get(`${API}/companies`);
export const createCompany = (data) => axios.post(`${API}/companies`, data);
export const updateCompany = (id, data) => axios.put(`${API}/companies/${id}`, data);
export const deleteCompany = (id) => axios.delete(`${API}/companies/${id}`);

// Passes
export const getPasses = (archived = false) => axios.get(`${API}/passes`, { params: { archived } });
export const createPass = (data) => axios.post(`${API}/passes`, data);
export const deletePass = (id) => axios.delete(`${API}/passes/${id}`);
export const markArrived = (id) => axios.put(`${API}/passes/${id}/arrive`);
export const markDeparted = (id) => axios.put(`${API}/passes/${id}/depart`);
export const markNoShow = (id) => axios.put(`${API}/passes/${id}/no-show`);

// Permanent Passes
export const getPermanentPasses = () => axios.get(`${API}/permanent-passes`);
export const createPermanentPass = (data) => axios.post(`${API}/permanent-passes`, data);
export const updatePermanentPass = (id, data) => axios.put(`${API}/permanent-passes/${id}`, data);
export const deletePermanentPass = (id) => axios.delete(`${API}/permanent-passes/${id}`);

// Stats
export const getStats = () => axios.get(`${API}/stats`);
